// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"934d860a","340":"fb332761","348":"af0c19d6","350":"b4620a55","654":"bf603020","704":"0c54bdf7","852":"39b9ca7e","868":"feba411e"}[chunkId] + ".js";
};